<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="合作商">
					<el-select v-model="listQuery.search.uid" clearable placeholder="请选择">
						<el-option v-for="item in partner_all" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="国家">
					<el-select v-model="listQuery.search.country_id" clearable placeholder="请选择">
						<el-option v-for="item in country_all" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-button type="success" @click="handleCreate">添加</el-button>
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:50px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>
		</el-card>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="id" label="ID"> </el-table-column>
				<el-table-column prop="uid_name" label="合作商"> </el-table-column>
				<el-table-column prop="country_id_name" label="国家"> </el-table-column>
				<el-table-column prop="commission_money" label="佣金(发货)"> </el-table-column>
				<el-table-column prop="commission_money_2" label="佣金(不发货)"> </el-table-column>
				<el-table-column prop="create_time" label="设置时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" with="250">
					<template slot-scope="{row,$index}">
						<!-- <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button> -->
						<el-popconfirm @confirm="handleDelete(row,$index)" @onConfirm="handleDelete(row,$index)"
							title="确定删除该数据？">
							<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
							</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 添加/编辑 -->
			<el-dialog title="设置" width="40%" :visible.sync="is_show_create">
				<span>
					<el-form ref="form" label-width="120px" size="medium">
						<el-form-item required label="合作商">
							<el-col :span="12">
								<el-select v-model="create_data.uid" clearable placeholder="请选择">
									<el-option v-for="item in partner_all" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item required label="国家">
							<el-col :span="12">
								<el-select v-model="create_data.country_id" clearable placeholder="请选择">
									<el-option v-for="item in country_all" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="佣金(发货)">
							<el-col :span="12">
								<el-input-number v-model="create_data.commission_money" :precision="2" :step="1"
									:min="0.00"></el-input-number>
							</el-col>
							<br>
							<span>需要仓库发货并签收</span>
						</el-form-item>
						<el-form-item label="佣金(不发货)">
							<el-col :span="12">
								<el-input-number v-model="create_data.commission_money_2" :precision="2" :step="1"
									:min="0.00"></el-input-number>
							</el-col>
							<br>
							<span>不需要仓库发货，但需要签收</span>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="createData()">确定
					</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		commissionSet,
		commissionList,
		commissionDel
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime,
		alertMsg
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	export default {
		components: {
			Pagination
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				checkbox_data: [], // 多选的数组
				loading: true,
				is_show_create: false,
				create_data: {},
				partner_all: [],
				country_all: [],
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},

			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: [],
				}
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			getList() { // 获取列表数据
				this.loading = true;
				commissionList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					if (this.listQuery.page == 1) {
						this.partner_all = r.partner_all;
						this.country_all = r.country_all;
					}
					this.loading = false;
				})
			},
			handleDelete(row, index) { // 数据的删除
				commissionDel(Qs.stringify(row)).then(response => {
					this.data_list.splice(index, 1)
					alertMsg(this, '删除成功', 'success');
				})
			},

			resetCreateData() { // 重置create_data数据
				this.create_data = {
					id: '',
					uid: '',
					country_id: '',
					commission_money: 0,
					commission_money_2: 0,
				}
			},
			handleCreate() {
				this.resetCreateData();
				this.is_show_create = !this.is_show_create;
			},
			handleUpdate(row) {
				this.create_data = Object.assign({}, row) // copy obj
				this.is_show_create = !this.is_show_create;
			},
			createData() {
				this.$store.commit('setAjaxLoading', true);
				commissionSet(Qs.stringify(this.create_data)).then(response => {
					this.getList();
					this.is_show_create = !this.is_show_create;
					alertMsg(this, '提交成功', 'success');
				})
			},
		}
	}
</script>
